var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWpclogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 841.89 396.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #084b72;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-12 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-13 {\n        fill: url(#radial-gradient-14);\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-15 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-11);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 460,
    cy: 224.46,
    fx: 460,
    fy: 224.46,
    r: 68.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 662.27,
    cy: 64.47,
    fx: 662.27,
    fy: 64.47,
    r: 205.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 662.27,
    cy: 64.47,
    fx: 662.27,
    fy: 64.47,
    r: 205.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 662.27,
    cy: 64.47,
    fx: 662.27,
    fy: 64.47,
    r: 205.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 662.27,
    cy: 64.47,
    fx: 662.27,
    fy: 64.47,
    r: 205.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 662.27,
    cy: 64.47,
    fx: 662.27,
    fy: 64.47,
    r: 205.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 662.27,
    cy: 64.47,
    fx: 662.27,
    fy: 64.47,
    r: 205.22,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 274.21,
    cy: 114.72,
    fx: 274.21,
    fy: 114.72,
    r: 127.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 274.21,
    cy: 114.72,
    fx: 274.21,
    fy: 114.72,
    r: 127.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 274.21,
    cy: 114.72,
    fx: 274.21,
    fy: 114.72,
    r: 127.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 274.21,
    cy: 114.72,
    fx: 274.21,
    fy: 114.72,
    r: 127.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 274.21,
    cy: 114.72,
    fx: 274.21,
    fy: 114.72,
    r: 127.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 274.21,
    cy: 114.72,
    fx: 274.21,
    fy: 114.72,
    r: 127.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 89.84,
    y1: 88.86,
    x2: 69.78,
    y2: 269.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#c85503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#e18d0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd215"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 150.99,
    cy: 95.66,
    fx: 150.99,
    fy: 95.66,
    r: 181.69,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M442.11,232.94c-.31,0-.56-.25-.56-.56v-69.96c0-.31.25-.56.56-.56s.56.25.56.56v69.96c0,.31-.25.56-.56.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M489.77,187.96h-5.32l-10.05-30.19h5.51l7.4,22.32,7.75-22.32h4.66l7.54,22.44,7.58-22.44h5.2l-10.09,30.19h-5.2l-7.52-21.93-7.46,21.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M527.22,183.85c-3-2.84-4.6-6.66-4.6-11.01s1.62-8.12,4.6-10.99c2.94-2.84,6.97-4.38,11.47-4.38s8.45,1.52,11.4,4.34c2.98,2.86,4.56,6.7,4.56,11.04s-1.58,8.24-4.56,11.05c-2.94,2.86-6.9,4.38-11.4,4.38s-8.53-1.58-11.47-4.42ZM549.33,172.83c0-6.02-4.56-10.52-10.64-10.52s-10.75,4.48-10.75,10.52,4.56,10.58,10.75,10.58,10.64-4.5,10.64-10.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M565.13,187.96h-5.32v-30.19h12.86c2.63,0,4.91.41,6.74,1.23,3.86,1.73,5.96,5.1,5.96,9.45,0,2.18-.51,4.09-1.54,5.73-1.23,1.87-3,3.23-5.28,4.05l6.9,9.72h-5.96l-6.18-8.79h-8.18v8.79ZM565.13,162.54v11.84h7.42c4.89,0,7.5-2.06,7.5-5.92s-2.61-5.92-7.5-5.92h-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M595.41,187.96h-5.32v-30.19h5.32v15.35l14.9-15.35h6.37l-12.97,13.66,13.64,16.52h-6.39l-10.85-12.64-4.71,4.79v7.85Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M639.97,187.96h-5.32v-30.19h12.86c2.63,0,4.91.41,6.74,1.23,3.86,1.73,5.96,5.1,5.96,9.45,0,2.18-.51,4.09-1.54,5.73-2.1,3.25-5.98,4.97-11.16,4.97h-7.54v8.79ZM639.97,162.54v11.84h7.42c4.89,0,7.5-2.06,7.5-5.92s-2.61-5.92-7.5-5.92h-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M689.28,187.96h-23.92v-30.19h24.02v4.77h-18.7v8.01h16.93v4.73h-16.93v7.89h18.6v4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M700.87,187.96h-5.32v-30.19h12.86c2.63,0,4.91.41,6.74,1.23,3.86,1.73,5.96,5.1,5.96,9.45,0,2.18-.51,4.09-1.54,5.73-1.23,1.87-3,3.23-5.28,4.05l6.9,9.72h-5.96l-6.18-8.79h-8.18v8.79ZM700.87,162.54v11.84h7.42c4.89,0,7.5-2.06,7.5-5.92s-2.61-5.92-7.5-5.92h-7.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M731.01,187.96h-5.18v-30.19h4.31l11.79,19.83,11.57-19.83h4.31l.08,30.19h-5.16l-.04-19.58-9.58,16.07h-2.57l-9.56-15.95v19.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M769.41,187.96h-5.32v-30.19h5.32v30.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M788.09,187.96h-5.28v-25.42h-9.95v-4.77h25.17v4.77h-9.95v25.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.16,235.08c-2.81-2.68-4.31-6.28-4.31-10.34s1.5-7.65,4.31-10.34c2.74-2.64,6.47-4.06,10.67-4.06,4.64,0,8.55,1.69,11.08,4.8l-3.29,3.2c-1.98-2.29-4.55-3.45-7.65-3.45-5.84,0-10.13,4.16-10.13,9.86s4.28,9.92,10.13,9.92c3.12,0,5.66-1.16,7.63-3.49l3.31,3.2c-2.56,3.12-6.51,4.83-11.11,4.83-4.24,0-7.96-1.45-10.63-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M510.08,235.06c-2.81-2.66-4.31-6.24-4.31-10.32s1.52-7.61,4.31-10.31c2.75-2.66,6.53-4.1,10.75-4.1s7.92,1.43,10.69,4.06c2.79,2.68,4.28,6.28,4.28,10.34s-1.48,7.72-4.28,10.36c-2.75,2.68-6.47,4.1-10.69,4.1s-7.99-1.48-10.75-4.14ZM530.81,224.74c0-5.64-4.28-9.86-9.98-9.86s-10.07,4.2-10.07,9.86,4.28,9.92,10.07,9.92,9.98-4.22,9.98-9.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M545.61,238.91h-4.99v-28.3h4.01l15.49,19.24v-19.24h4.99v28.3h-3.99l-15.51-19.26v19.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M570.9,235.35l1.95-4.06c2.02,2.14,5.68,3.52,9.13,3.52,1.54,0,2.73-.17,3.64-.52,1.7-.64,2.52-1.68,2.52-3.1,0-.79-.21-1.37-.71-1.85-.98-.93-2.58-1.56-5.34-2.18-5.24-1.18-10.4-2.58-10.4-8.51,0-1.5.4-2.93,1.19-4.18,1.7-2.7,5.12-4.14,9.75-4.14,3.53,0,7.17,1.04,9.46,2.75l-1.75,4.16c-2.16-1.64-4.89-2.52-7.71-2.52-1.5,0-2.66.19-3.56.56-1.66.66-2.47,1.71-2.47,3.18,0,.85.23,1.43.75,1.89.94.89,2.45,1.5,5.3,2.12,5.18,1.27,10.42,2.54,10.42,8.46,0,1.48-.42,2.91-1.21,4.1-1.73,2.72-5.22,4.18-9.88,4.18-4.41,0-8.84-1.52-11.08-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M598.86,226.62v-16.01h4.99v15.87c0,5.47,2.35,8.17,7.11,8.17s7.15-2.66,7.15-8.17v-15.87h4.87v16.01c0,7.99-4.37,12.58-12.06,12.58s-12.06-4.6-12.06-12.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M651.18,238.91h-22.42v-28.3h4.99v23.81h17.43v4.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M663.54,238.91h-4.95v-23.83h-9.32v-4.47h23.6v4.47h-9.32v23.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M676.28,238.91h-5.24l12.83-28.3h4.55l12.87,28.3h-5.34l-3.26-7.44h-13.16l-3.26,7.44ZM686.1,216.49l-4.72,10.77h9.46l-4.74-10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M710.61,238.91h-4.99v-28.3h4.01l15.49,19.24v-19.24h4.99v28.3h-3.99l-15.51-19.26v19.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740.21,235.08c-2.81-2.68-4.31-6.28-4.31-10.34s1.5-7.65,4.31-10.34c2.74-2.64,6.47-4.06,10.67-4.06,4.64,0,8.55,1.69,11.08,4.8l-3.29,3.2c-1.98-2.29-4.55-3.45-7.65-3.45-5.84,0-10.13,4.16-10.13,9.86s4.28,9.92,10.13,9.92c3.12,0,5.66-1.16,7.63-3.49l3.31,3.2c-2.56,3.12-6.51,4.83-11.11,4.83-4.24,0-7.96-1.45-10.63-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M781.04,238.91h-4.95v-9.88l-11.23-18.41h5.43l8.38,13.79,8.46-13.79h5.14l-11.23,18.49v9.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.04,157.98c-6.4-6.4-15.24-10.36-25-10.36h-63.38v103.98h16.12v-33.26h47.26c19.52,0,35.36-15.83,35.36-35.36,0-9.76-3.96-18.6-10.35-25ZM280.23,193.57c0,6.07-4.44,11.24-10.44,12.11-16.38,2.39-30.85-9.16-50.01-5.95v-28.78c0-6.22,4.67-11.49,10.86-12.17,16.05-1.76,31.48,7.51,49.6,3.1v31.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M252.05,164.09l-1.02,3.15s-.05.07-.09.07h-3.32c-.09,0-.13.12-.06.17l2.68,1.95s.05.07.03.11l-1.02,3.15c-.03.09.07.16.15.11l2.68-1.95s.08-.02.11,0l2.68,1.95c.07.05.17-.02.15-.11l-1.02-3.15s0-.08.03-.11l2.68-1.95c.07-.05.04-.17-.06-.17h-3.32s-.08-.03-.09-.07l-1.02-3.15c-.03-.09-.15-.09-.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.26,192.85l-1.02-3.15c-.03-.09-.15-.09-.18,0l-1.02,3.15s-.05.07-.09.07h-3.32c-.09,0-.13.12-.06.17l2.68,1.95s.05.07.03.11l-1.02,3.15c-.03.09.07.16.15.11l2.68-1.95s.08-.02.11,0l2.68,1.95c.07.05.17-.02.15-.11l-1.02-3.15s0-.08.03-.11l2.68-1.95c.07-.05.04-.17-.06-.17h-3.32s-.08-.03-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M241.2,186.95l-1.02-3.15c-.03-.09-.15-.09-.18,0l-1.02,3.15s-.05.07-.09.07h-3.32c-.09,0-.13.12-.06.17l2.68,1.95s.05.07.03.11l-1.02,3.15c-.03.09.07.16.15.11l2.68-1.95s.08-.02.11,0l2.68,1.95c.07.05.17-.02.15-.11l-1.02-3.15s0-.08.03-.11l2.68-1.95c.07-.05.04-.17-.06-.17h-3.32s-.08-.03-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M264.39,187.43l-1.02-3.15c-.03-.09-.15-.09-.18,0l-1.02,3.15s-.05.07-.09.07h-3.32c-.09,0-.13.12-.06.17l2.68,1.95s.05.07.03.11l-1.02,3.15c-.03.09.07.16.15.11l2.68-1.95s.08-.02.11,0l2.68,1.95c.07.05.17-.02.15-.11l-1.02-3.15s0-.08.03-.11l2.68-1.95c.07-.05.04-.17-.06-.17h-3.32s-.08-.03-.09-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M260.87,179.13l2.68-1.95s.08-.02.11,0l2.68,1.95c.07.05.17-.02.15-.11l-1.02-3.15s0-.08.03-.11l2.68-1.95c.07-.05.04-.17-.06-.17h-3.32s-.08-.03-.09-.07l-1.02-3.15c-.03-.09-.15-.09-.18,0l-1.02,3.15s-.05.07-.09.07h-3.32c-.09,0-.13.12-.06.17l2.68,1.95s.05.07.03.11l-1.02,3.15c-.03.09.07.16.15.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M237.02,179.13l2.68-1.95s.08-.02.11,0l2.68,1.95c.07.05.17-.02.15-.11l-1.02-3.15s0-.08.03-.11l2.68-1.95c.07-.05.04-.17-.06-.17h-3.32s-.08-.03-.09-.07l-1.02-3.15c-.03-.09-.15-.09-.18,0l-1.02,3.15s-.05.07-.09.07h-3.32c-.09,0-.13.12-.06.17l2.68,1.95s.05.07.03.11l-1.02,3.15c-.03.09.07.16.15.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.85,147.62l-33.34,99.74h-20.18l-19.23-32.52c4.02-.53,11.15-1.85,15.66-4.86l11.67,18.88,29.03-81.24h16.39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M100.51,208.88l-10.54,22.61-30.13-83.87h-15.98l34.4,99.74h21.04l16.07-33.06c-8.03-.5-14.85-5.42-14.85-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M151.26,147.56v31.29c0,5.06-1.27,9.83-3.51,14.03,0,0,0,0,0,0-1.17,2.2-2.61,4.23-4.26,6.07-1.92,2.12-4.13,3.97-6.58,5.47-4.61,3.49-15.89,4.45-15.89,4.45-5.79-38.34,14.56-52.2,15.12-52.63,1.7-1.33,3.49-2.58,5.37-3.72,1.88-1.15,3.78-2.19,5.72-3.09l4.02-1.86s0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.86,208.18c-3.23-.71-6.26-1.94-9.01-3.61-2.55-1.53-4.86-3.43-6.85-5.62-4.83-5.35-7.78-12.4-7.78-20.1v-27.55c16.05,8.72,22.97,19.57,25.4,24.4-2.46,7.96-3.68,18.48-1.76,32.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.36,168.68c4.32-9,11.48-15.86,11.58-15.94-2.38-2.66-5.17-4.96-8.25-6.8l-1.45-.87-1.45.87c-4.6,2.75-8.53,5.17-11.46,9.65,0,0,8.33,7.25,11.04,13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.11,199.51c0-28.25,24.02-51.89,52.47-51.89,14.22,0,27.1,5.96,36.52,15.38l-12.88,11.92c-5.96-6.73-14.61-10.76-23.83-10.76-18.07,0-33.06,16.14-33.06,35.36s14.99,35.56,33.25,35.56c9.23,0,18.07-4.23,24.22-11.15l12.88,11.72c-9.61,9.8-22.49,15.95-37.29,15.95-28.25,0-52.28-23.83-52.28-52.08Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWpclogo);
export default __webpack_public_path__ + "static/media/WPC LOGO.ea2a8730cb81e3ec444bca7a50997926.svg";
export { ForwardRef as ReactComponent };